
const digest = '8079ccb05706631a583c0372cc6a20604374bdc8e2119063a7bb3cf9193e9c6b';
const classes = {"wrapper":"_wrapper_8nqrq_1","created":"_created_8nqrq_4"};
const css = `._wrapper_8nqrq_1 {
  font-family: Rubik, "sans-serif";
}
._wrapper_8nqrq_1 ._created_8nqrq_4 {
  padding: 24px 0;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  